import { Component, ChangeDetectionStrategy, Input, TemplateRef, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';

@Component({
  selector: 'app-backward-btn',
  templateUrl: './backward-btn.component.html',
  styleUrls: ['./backward-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackwardBtnComponent implements AfterViewInit {
  @Input() public templateRef: TemplateRef<any> | null;
  @Input() public width = 625;
  @Input() public height = 20;
  @Input() public link: string;
  @Input() public defaultTooltip = true;
  @Input() public titleName: string | undefined;
  @Input() public backwardTitle: string | undefined;
  @ViewChild('title') public title: ElementRef<HTMLElement>;
  public icons = CustomIcons;
  public customTooltipWidth = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    this.customTooltipWidth = this.title?.nativeElement?.clientWidth;
    this.cdr.detectChanges();
  }
}
